import React, { useState } from "react";
import { motion } from "framer-motion";
import { howWeWorksData } from "../utility/howWeWorksData";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const HowWeWorks = () => {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <section className="relative min-h-[70vh] lg:min-h-[75vh] xl:min-h-[60vh] 2xl:min-h-[50vh] overflow-hidden">
      {/* Background image */}
      <motion.div className="absolute inset-0 w-full h-full">
        <div className="absolute inset-0 bg-slate-100"></div>
      </motion.div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 flex flex-col justify-center  py-8 ">
        {/* Header - Centered */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="mb-12 lg:mb-12 text-center"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-large text-[#f48220] mb-3">
            Our AI Solution Implementation Process
          </h2>
          <p className="text-gray-600 text-base sm:text-lg mx-auto max-w-md md:max-w-xl">
            A streamlined approach to delivering intelligent solutions
          </p>
        </motion.div>

        {/* Horizontal process stepper - Centered */}
        <div className="relative w-full">
          {/* Step indicators - Centered and scrollable on mobile */}
          <div className="relative w-full px-2">
            <div
              className="flex overflow-x-auto pb-4 hide-scrollbar snap-x snap-mandatory scroll-pl-4 pr-4"
              style={{
                scrollbarWidth: "none", // For Firefox
                msOverflowStyle: "none", // For IE
              }}
            >
              <div className="flex gap-2 sm:gap-4 mx-auto  pr-4">
                {howWeWorksData.map((step, index) => (
                  <button
                    key={step.id}
                    onClick={() => setActiveStep(index)}
                    className={`flex-shrink-0 px-4 py-2 sm:px-6 sm:py-3 rounded-full font-medium text-sm sm:text-base transition-all snap-start ${
                      activeStep === index
                        ? "bg-[#f48220] text-white shadow-lg"
                        : "bg-white/20 text-gray-700 border-[#f48220] border hover:bg-white/30"
                    }`}
                  >
                    {step.title}
                  </button>
                ))}
              </div>
            </div>
          </div>
          {/* Active step content - Centered */}
          <motion.div
            key={activeStep}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="bg-white/90 backdrop-blur-sm rounded-xl mt-4 p-6 shadow-lg mx-auto w-full max-w-2xl border-t-4 border-orange-500                                                            "
          >
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 text-center">
              {howWeWorksData[activeStep].title}
            </h3>
            <ul className="space-y-3">
              {howWeWorksData[activeStep].description.map((item, key) => (
                <li key={key} className="flex items-start">
                  <IoMdCheckmarkCircleOutline className="text-[#f48220] text-lg sm:text-xl mt-0.5 mr-3 flex-shrink-0" />
                  <span className="text-gray-700 text-base sm:text-lg">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Navigation arrows - Centered and always visible */}
          <div className="flex justify-center mt-6 space-x-4">
            <button
              onClick={() => setActiveStep((prev) => Math.max(0, prev - 1))}
              className="p-2 sm:p-3 rounded-full bg-gray-300 disabled:opacity-30"
              disabled={activeStep === 0}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
            <div className="flex items-center text-sm sm:text-base">
              {activeStep + 1} / {howWeWorksData.length}
            </div>
            <button
              onClick={() =>
                setActiveStep((prev) =>
                  Math.min(howWeWorksData.length - 1, prev + 1)
                )
              }
              className="p-2 sm:p-3 rounded-full bg-gray-300 disabled:opacity-30"
              disabled={activeStep === howWeWorksData.length - 1}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWorks;
